import styled from 'styled-components';

export const MatchingScoreWrapper = styled.div`
  .ant-progress-circle .ant-progress-inner {
    background-color: ${({ theme }) => theme.palette.green};
  }
  .ant-progress-circle .ant-progress-text {
    color: white;
  }
  .ant-progress-inner:not(.ant-progress-circle-gradient)
    .ant-progress-circle-path {
    stroke: white;
    stroke-width: 8;
  }
  .ant-progress-circle-trail {
    stroke-width: 8;
    opacity: 0.7;
  }
  .progress-style {
    background-color: ${({ theme }) => theme.palette.green};
    padding: 2px;
    border-radius: 50%;
  }
`;
